import { render, staticRenderFns } from "./showChangeLogs.vue?vue&type=template&id=3433b4f1&scoped=true"
import script from "./showChangeLogs.vue?vue&type=script&lang=js"
export * from "./showChangeLogs.vue?vue&type=script&lang=js"
import style0 from "./showChangeLogs.vue?vue&type=style&index=0&id=3433b4f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3433b4f1",
  null
  
)

export default component.exports